export default {
  placeholder: 'Wybierz klienta',
};
